exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".order-state-0-bg{background-color:#f94144}.order-state-10-bg{background-color:#f3722c}.order-state-20-bg{background-color:#f8961e}.order-state-23-bg{background-color:#f9c74f}.order-state-24-bg{background-color:#ff986c}.order-state-26-bg{background-color:#90be6d}.order-state-30-bg{background-color:#577590}.order-state-40-bg{background-color:#43aa8b}.fuwu-base .mint-button--primary{background:#20ad20!important}.fuwu-base .distributor-footer-wrap .distributor-footer .item-wrap.is-selected .item{color:#20ad20}", ""]);

// exports
